import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import Export from './options/export';
import FormModal from './options/form_modal';
import Import from './options/import';
import Option from './options/option';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

import './options/styles/options.scss';

export class Options extends React.Component {
  static propTypes = {
    admin: PropTypes.bool,
    className: PropTypes.string,
    defaultOverrides: PropTypes.object,
    liquidContext: PropTypes.object,
    options: PropTypes.array.isRequired,
    readOnlyOptions: PropTypes.bool,
    values: PropTypes.object.isRequired,

    onOptionsChange: PropTypes.func,
    onOptionsReorder: PropTypes.func,
    onOverrideOptionDefault: PropTypes.func,
    onUseOptionDefault: PropTypes.func,
    onValuesChange: PropTypes.func.isRequired
  }

  state = {}

  showModal = () => {
    this.setState({ creating: true });
  }

  hideModal = () => {
    this.setState({ creating: false });
  }

  handleOptionAdd = (option) => {
    const options = this.props.options.concat(option);
    this.props.onOptionsChange(options);
    this.setState({ creating: false });
  }

  handleOptionChange = (option, index) => {
    // Lookup by index to allow the ID to be changed
    const options = this.props.options.slice(0, index)
      .concat(option)
      .concat(this.props.options.slice(index + 1));

    this.props.onOptionsChange(options);
  }

  handleOptionDelete = (option, index) => {
    const options = this.props.options.slice(0, index).concat(this.props.options.slice(index + 1));
    this.props.onOptionsChange(options);
  }

  handleOptionSwap = (index1, index2) => {
    const options = [...this.props.options];
    const option = options[index1];
    options[index1] = options[index2];
    options[index2] = option;
    this.props.onOptionsReorder(options);
  }

  inOverrideMode() {
    return !!this.props.defaultOverrides;
  }

  render() {
    const className = classNames('email-options', this.props.className, {
      admin: this.props.admin,
      'override-mode': this.inOverrideMode()
    });

    return (
      <div className={className}>
        {this.renderOptions()}
        {this.renderAdminControls()}
      </div>
    );
  }

  renderOptions() {
    return (
      <div className="email-options-list">
        {this.props.options.map((option, i) => this.renderOption(option, i))}
      </div>
    );
  }

  renderOption(option, index) {
    const inOverrideMode = this.inOverrideMode();
    const overridden = inOverrideMode && this.props.defaultOverrides.hasOwnProperty(option.id);

    return (
      <Option
        admin={this.props.admin}
        disabled={option.hidden.evaluated || (inOverrideMode && !overridden)}
        key={option.id}
        index={index}
        liquidContext={this.props.liquidContext}
        option={option}
        options={this.props.options}
        overridden={overridden}
        overrideMode={inOverrideMode}
        readOnlyOption={this.props.readOnlyOptions}
        value={this.props.values[option.id]}
        onChange={this.props.onValuesChange}
        onOptionChange={this.handleOptionChange}
        onOptionDelete={this.handleOptionDelete}
        onOverrideDefault={this.props.onOverrideOptionDefault}
        onReorder={this.handleOptionSwap}
        onUseDefault={this.props.onUseOptionDefault}
      />
    );
  }

  renderAdminControls() {
    if (!this.props.admin || this.props.readOnlyOptions) {
      return null;
    }

    return <React.Fragment>
      <div className="email-option-admin-controls">
        <button className="btn btn-light btn-sm" onClick={this.showModal}>
          <FontAwesomeIcon icon={faPlus} size="sm" />
          New Option
        </button>

        <div className="d-flex gap-2">
          <Export
            className="btn btn-light btn-sm right-buffer-sm"
            options={this.props.options}
          />

          <Import
            className="btn btn-light btn-sm"
            onImport={this.props.onOptionsChange}
          />
        </div>
      </div>

      <FormModal
        liquidContext={this.props.liquidContext}
        options={this.props.options}
        show={this.state.creating}
        onCancel={this.hideModal}
        onOk={this.handleOptionAdd}
      />
    </React.Fragment>;
  }
}

export default reorderableList(Options);
